import { useEffect, useState } from 'react';
import sharesTitlesStatus from 'modules/partners/pages/TitleRegistryBook/constants/sharesTitlesStatus';

import { SharesTitle, Society, Transaction } from 'types';
import { getTitleByTransaction } from '../utils/getTitleByTransaction';

type Props = {
  sharesTitles: SharesTitle[];
  society: Society;
  transaction: Transaction;
};
const CANCELLED_STATUS = sharesTitlesStatus[2].value;

export const useGetTransactionTitle = ({
  sharesTitles,
  society,
  transaction,
}: Props) => {
  const [transactionTitle, setTransactionTitle] = useState<SharesTitle | null>(
    null
  );
  const [titleWatermarkText, setTitleWatermarkText] = useState<string>('');

  useEffect(() => {
    const title = getTitleByTransaction(sharesTitles, transaction);

    if (title) {
      setTransactionTitle(title);
      const titleWatermarkText =
        title?.status === CANCELLED_STATUS ? 'TÍTULO CANCELADO' : '';

      setTitleWatermarkText(titleWatermarkText);
    } else {
      setTransactionTitle(null);
    }
  }, [transaction, sharesTitles, society]);

  return { data: { transactionTitle, titleWatermarkText } };
};
